require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _color = _interopRequireDefault(require("color"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _MaterialCommunityIcon = _interopRequireDefault(require("../MaterialCommunityIcon"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _theming = require("../../core/theming");

var _ListAccordionGroup = require("./ListAccordionGroup");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/List/ListAccordion.tsx";

var ListAccordion = function (_React$Component) {
  (0, _inherits2["default"])(ListAccordion, _React$Component);

  function ListAccordion() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ListAccordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ListAccordion)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      expanded: _this.props.expanded || false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePress", function () {
      _this.props.onPress && _this.props.onPress();

      if (_this.props.expanded === undefined) {
        _this.setState(function (state) {
          return {
            expanded: !state.expanded
          };
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(ListAccordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          left = _this$props.left,
          title = _this$props.title,
          description = _this$props.description,
          children = _this$props.children,
          theme = _this$props.theme,
          titleStyle = _this$props.titleStyle,
          descriptionStyle = _this$props.descriptionStyle,
          titleNumberOfLines = _this$props.titleNumberOfLines,
          descriptionNumberOfLines = _this$props.descriptionNumberOfLines,
          style = _this$props.style,
          id = _this$props.id,
          testID = _this$props.testID;
      var titleColor = (0, _color["default"])(theme.colors.text).alpha(0.87).rgb().string();
      var descriptionColor = (0, _color["default"])(theme.colors.text).alpha(0.54).rgb().string();
      var expandedInternal = this.props.expanded !== undefined ? this.props.expanded : this.state.expanded;
      return React.createElement(_ListAccordionGroup.ListAccordionGroupContext.Consumer, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195
        }
      }, function (groupContext) {
        if (groupContext !== null && !id) {
          throw new Error('List.Accordion is used inside a List.AccordionGroup without specifying an id prop.');
        }

        var expanded = groupContext ? groupContext.expandedId === id : expandedInternal;
        var handlePress = groupContext && id !== undefined ? function () {
          return groupContext.onAccordionPress(id);
        } : _this2.handlePress;
        return React.createElement(_reactNative.View, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 210
          }
        }, React.createElement(_TouchableRipple["default"], {
          style: [styles.container, style],
          onPress: handlePress,
          accessibilityTraits: "button",
          accessibilityComponentType: "button",
          accessibilityRole: "button",
          testID: testID,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211
          }
        }, React.createElement(_reactNative.View, {
          style: styles.row,
          pointerEvents: "none",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 219
          }
        }, left ? left({
          color: expanded ? theme.colors.primary : descriptionColor
        }) : null, React.createElement(_reactNative.View, {
          style: [styles.item, styles.content],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 227
          }
        }, React.createElement(_Text["default"], {
          numberOfLines: titleNumberOfLines,
          style: [styles.title, {
            color: expanded ? theme.colors.primary : titleColor
          }, titleStyle],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 228
          }
        }, title), description && React.createElement(_Text["default"], {
          numberOfLines: descriptionNumberOfLines,
          style: [styles.description, {
            color: descriptionColor
          }, descriptionStyle],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 241
          }
        }, description)), React.createElement(_reactNative.View, {
          style: [styles.item, description ? styles.multiline : undefined],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 255
          }
        }, React.createElement(_MaterialCommunityIcon["default"], {
          name: expanded ? 'chevron-up' : 'chevron-down',
          color: titleColor,
          size: 24,
          direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 261
          }
        })))), expanded ? React.Children.map(children, function (child) {
          if (left && React.isValidElement(child) && !child.props.left && !child.props.right) {
            return React.cloneElement(child, {
              style: [styles.child, child.props.style]
            });
          }

          return child;
        }) : null);
      });
    }
  }]);
  return ListAccordion;
}(React.Component);

(0, _defineProperty2["default"])(ListAccordion, "displayName", 'List.Accordion');
(0, _defineProperty2["default"])(ListAccordion, "defaultProps", {
  titleNumberOfLines: 1,
  descriptionNumberOfLines: 2
});

var styles = _reactNative.StyleSheet.create({
  container: {
    padding: 8
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  multiline: {
    height: 40,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    fontSize: 16
  },
  description: {
    fontSize: 14
  },
  item: {
    margin: 8
  },
  child: {
    paddingLeft: 64
  },
  content: {
    flex: 1,
    justifyContent: 'center'
  }
});

var _default = (0, _theming.withTheme)(ListAccordion);

exports["default"] = _default;